





export default
  methods:
    click: () ->
      @$emit('click')
